<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm">
            <el-form-item label="供应商/通道名称：">
                <el-input v-model.trim="searchForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getAccountHandle" icon="el-icon-search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="showAddAccount" icon="el-icon-edit">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border highlight-current-row>
            <el-table-column prop="name" label="供应商名称" width="100px"></el-table-column>
            <el-table-column prop="alias" label="通道" width="80px"></el-table-column>
            <el-table-column prop="accountName" label="主账号"></el-table-column>
            <el-table-column prop="pwd" label="主密码"></el-table-column>
            <el-table-column prop="limitName" label="限速设置" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="isXuName" label="虚量开关" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="xuData" label="通道虚量%" align="center" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="newAccountName" label="次账号"></el-table-column>
            <el-table-column prop="newPwd" label="次密码"></el-table-column>
            <el-table-column prop="pwdKey" label="密钥"></el-table-column> -->
            <el-table-column prop="typeName" label="所属类别" width="100px"></el-table-column>
            <el-table-column label="状态" width="100px">
                <template slot-scope="scope">
                    <span v-if="scope.row.state == 0" style="color: red">{{ scope.row.stateName }}</span>
                    <span v-if="scope.row.state == 1" style="color: green">{{ scope.row.stateName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180px">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showEditAccount(scope.row.id)"
                        icon="el-icon-edit">编辑</el-button>
                    <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">{{
                        showbtnText(scope.row.state) }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" :title="title" :visible.sync="accountVisibale" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="addOrEditAccountForm" :model="addOrEditAccountForm" :rules="addOrEditAccountRules"
                label-width="120px">
                <el-form-item label="通道名称：" prop="name">
                    <el-input v-model.trim="addOrEditAccountForm.name" clearable></el-input>
                </el-form-item>
                <el-form-item label="通道：" prop="alias">
                    <el-input v-model.trim="addOrEditAccountForm.alias" clearable></el-input>
                </el-form-item>
                <el-form-item label="主账号：" prop="accountName">
                    <el-input v-model.trim="addOrEditAccountForm.accountName" clearable></el-input>
                </el-form-item>
                <el-form-item label="主密码：" prop="pwd">
                    <el-input v-model.trim="addOrEditAccountForm.pwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="次账号：" prop="newAccountName">
                    <el-input v-model.trim="addOrEditAccountForm.newAccountName" clearable></el-input>
                </el-form-item>
                <el-form-item label="次密码：" prop="newPwd">
                    <el-input v-model.trim="addOrEditAccountForm.newPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="密钥：" prop="pwdKey">
                    <el-input v-model.trim="addOrEditAccountForm.pwdKey" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="供应商链接：" prop="questUrl">
                    <el-input v-model.trim="addOrEditAccountForm.questUrl" clearable></el-input>
                </el-form-item>

                <el-form-item label="实名跳转链接：" prop="flowRatePool">
                    <el-input v-model.trim="addOrEditAccountForm.flowRatePool" placeholder="控制实名跳转，电信卡请填 电信 ，联通卡 填联通。特殊实名链接 请直接填链接" clearable></el-input>
                </el-form-item>

                 <el-form-item label="设备共享套餐：" prop="isXu">
                    <p style="color: red;">智能选网必须开启，但会产生格外的抵消费用（建议关闭）</p>
                    <el-radio-group v-model="addOrEditAccountForm.sharePkg">
                        <el-radio :label="1">开启共享</el-radio>
                        <el-radio :label="0">关闭共享</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="设备管理链接：" prop="sheUrl">
                    <el-input v-model.trim="addOrEditAccountForm.sheUrl" placeholder="选填 充值端展示设备管理" clearable></el-input>
                </el-form-item>
                 <el-form-item label="限速类型：" prop="shebeiLimit">
                    <el-radio-group v-model="addOrEditAccountForm.shebeiLimit">
                        <el-radio :label="0">普通限速</el-radio>
                        <el-radio :label="1">设备限速</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="通道虚量：" prop="isXu">
                    <el-radio-group v-model="addOrEditAccountForm.isXu">
                        <el-radio :label="1">开启虚量</el-radio>
                        <el-radio :label="0">关闭虚量</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="虚量百分比%：" prop="xuData" v-if="addOrEditAccountForm.isXu==1">
                    <el-input v-model.trim="addOrEditAccountForm.xuData" placeholder="通道虚量开启后，会和套餐虚量/单卡虚量做比较。谁虚的多就用谁" clearable></el-input>
                </el-form-item>

                <el-form-item label="对接类型：">
                    <el-select v-model="addOrEditAccountForm.type" placeholder="请选择">
                        <el-option v-for="item in supplierOption" :value="item.code" :key="item.description"
                            :label="item.description"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="停机类型：" prop=""  v-if="addOrEditAccountForm.type==3">
                    <el-radio-group v-model="addOrEditAccountForm.stopType">
                        <el-radio :label="1">开停数据通信</el-radio>
                        <el-radio :label="0">停复机</el-radio>
                    </el-radio-group>
                </el-form-item>  

                <p v-if="addOrEditAccountForm.type==9||addOrEditAccountForm.shebeiLimit==1"  style="color: black;font-weight:bold;">对应名称只是方便统一辨认，对应的速率可自定义设置（设备默认kbps）</p>
                <el-form-item label="限速速率一：" prop="oneLimit" v-if="addOrEditAccountForm.type==9 ||addOrEditAccountForm.shebeiLimit==1">
                    <el-input v-model.trim="addOrEditAccountForm.oneLimit" placeholder="对应名称-解除限速速率" clearable></el-input>
                </el-form-item>
                <el-form-item label="限速速率二：" prop="twoLimit" v-if="addOrEditAccountForm.type==9 ||addOrEditAccountForm.shebeiLimit==1">
                    <el-input v-model.trim="addOrEditAccountForm.twoLimit" placeholder="对应名称-APN-AMBR=1Mbps" clearable></el-input>
                </el-form-item>
                <el-form-item label="限速速率三：" prop="threeLimit" v-if="addOrEditAccountForm.type==9 ||addOrEditAccountForm.shebeiLimit==1">
                    <el-input v-model.trim="addOrEditAccountForm.threeLimit" placeholder="对应名称-APN-AMBR=3Mbps" clearable></el-input>
                </el-form-item>
                <el-form-item label="限速速率四：" prop="fourLimit" v-if="addOrEditAccountForm.type==9 ||addOrEditAccountForm.shebeiLimit==1">
                    <el-input v-model.trim="addOrEditAccountForm.fourLimit" placeholder="对应名称-APN-AMBR=5Mbps" clearable></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtAccountHandle">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getSupplierListPage, addAccount, editAccount, getAccountInfo, changeAccountState, changeSimIntoHistory } from '@/api/system.js'
import { mapGetters } from "vuex";
import common from '@/utils/common.js'
export default {
    data() {
        return {
            searchForm: {
                name: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },
            addFlag: false,
            accountVisibale: false,
            currentId: '',
            addOrEditAccountForm: {
                stopType:'',
                name: '',
                alias: '',
                accountName: '',
                pwd: '',
                newAccountName: '',
                newPwd: '',
                pwdKey: '',
                flowRatePool: '',
                questUrl: '',
                type: '',
                isAuth: '2',
                limitId: '',
                isXu: '0',
                xuData: '',
                sheUrl:'',
                oneLimit:'',
                twoLimit:'',
                threeLimit:'',
                fourLimit:'',
                sharePkg:'0',
                shebeiLimit:'',
            },
            title: '',
            branchSupplierOption: [],
            supplierOption1: [
                {
                    code: 1,
                    description: '无需绑定'
                },
                {
                    code: 2,
                    description: '绑定手机号'
                }
            ],
            supplierOption: [],
            addOrEditAccountRules: {
                name: [
                    { required: true, message: '请输入供应商名称', trigger: 'blur' }
                ],
                alias: [
                    { required: true, message: '请输入通道', trigger: 'blur' }
                ],
                accountName: [
                    { required: true, message: '请输入账户', trigger: 'blur' }
                ],
                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                pwdKey: [
                    { required: true, message: '请输入密钥', trigger: 'blur' }
                ],
                flowRatePool: [
                    { required: true, message: '请输入流量池', trigger: 'blur' }
                ],
                questUrl: [
                    { required: false, message: '请输入供应商网站链接', trigger: 'blur' }
                ]
            }
        }
    }, computed: {
        ...mapGetters("menu", {
            hasAuthority: "hasAuthority"
        })
    },
    methods: {
        changeSimIntoHistoryHandler(id) {
            let self = this;
            self.$confirm("您确定将此通道下的SIM卡,导入历史库吗", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                changeSimIntoHistory(id).then(res => {
                    let result = res.data;
                    if (result.code == 200) {
                        self.$message.success('卡片已导入历史表,需要查询历史,请移步历史卡片管理.');
                    } else {
                        self.$message.error(res.data.message);
                    }
                });
            });
        },
        cancel() {
            this.accountVisibale = false;
            this.$refs.addOrEditAccountForm.resetFields();
        },
        showbtnText(state) {
            return common.showTxtByState(state, { 0: '启用', 1: '禁用' })
        },
        getAccountHandle($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getSupplierListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showAddAccount() {
            this.title = '新增账户';
            this.addFlag = true;
            this.accountVisibale = true;
        },
        showEditAccount(id) {
            this.title = '修改账户';
            this.addFlag = false;
            this.accountVisibale = true;
            this.currentId = id;
            var data = {
                id
            }
            getAccountInfo(data).then(res => {
                var result = res.data;
                if (result.code == 200) {
                    this.addOrEditAccountForm.name = result.data.name;
                    for (var key in this.addOrEditAccountForm) {
                        this.addOrEditAccountForm[key] = result.data[key];
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        addOrEidtAccountHandle() {
            this.$refs.addOrEditAccountForm.validate(valid => {
                if (valid) {
                    var data = this.addOrEditAccountForm;
                    if (this.addFlag == true) {
                        addAccount(data).then(res => callback(res))
                    } else {
                        data.id = this.currentId
                        editAccount(data).then(res => callback(res))
                    }
                }
                var _this = this;
                function callback(res) {
                    if (res.data.code == 200) {
                        _this.getAccountHandle();
                        _this.accountVisibale = false;

                    } else {
                        _this.$message.error(res.data.message)
                    }
                }
            })
        },
        changeStateHandle(id) {
            var data = {
                id
            }
            changeAccountState(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                    this.getAccountHandle();
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getAccountHandle();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val
            this.getAccountHandle();
        }
    },
    created() {
        common.getSupplierLimitOptionCom(this, 'branchSupplierOption')
        this.getAccountHandle();
        common.getSupplierOptionCom(this, 'supplierOption');
    }
}
</script>
<style lang="less" scoped></style>

